module.exports = __webpack_public_path__ + "img/STERiGLIDE_01.2faca4a4.jpg";